import { POST } from "../../APiHelper/API";

export const addDerbyToTeam = (team_id, derbies, onSuccess, onError) => {

    const data = {
        derbies: derbies
    }
    POST(`/api/v1/leagues/team/${team_id}/set_derbies`, data, onSuccess, onError)
}